import React from 'react';
import Tooltip from '../Tooltip';
const Flyout = props => {
  return /*#__PURE__*/React.createElement(Tooltip, props);
};
Flyout.displayName = 'Flyout';
Flyout.defaultProps = {
  trigger: Tooltip.TRIGGER_EVENTS.CLICK,
  variant: Tooltip.VARIANTS.LIGHT,
  shouldWrapChildren: false,
  containerPadding: 16,
  delayShow: 100,
  delayHide: 0
};
Flyout.propTypes = Tooltip.propTypes;
export default Object.assign(Flyout, {
  VARIANTS: Tooltip.VARIANTS,
  PLACEMENTS: Tooltip.PLACEMENTS,
  TRIGGER_EVENTS: Tooltip.TRIGGER_EVENTS,
  TRIGGER_TARGETS: Tooltip.TRIGGER_TARGETS
});
//# sourceMappingURL=Flyout.js.map